import { validateVimeoUrl, validateYouTubeUrl } from "./validateVideoLink";

export const getVideoSource = async (url) => {
  if (validateYouTubeUrl(url)) return "youtube";
  if (await validateVimeoUrl(url)) return "vimeo";
  return null;
};
